var _path, _mask, _g, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1Enabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 227,
    viewBox: "0 0 227 227",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.038 226.076C175.467 226.076 226.076 175.467 226.076 113.038C226.076 50.6089 175.467 0 113.038 0C50.6089 0 0 50.6089 0 113.038C0 175.467 50.6089 226.076 113.038 226.076Z",
    fill: "#FFB151"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 227,
    height: 227
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.038 226.076C175.467 226.076 226.076 175.467 226.076 113.038C226.076 50.6089 175.467 0 113.038 0C50.6089 0 0 50.6089 0 113.038C0 175.467 50.6089 226.076 113.038 226.076Z",
    fill: "#FFB151"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.747 -50.4688C194.351 -50.4688 218.302 -24.2738 228.514 -14.046C238.725 -3.81826 267.027 13.4971 267.027 29.1011C267.027 39.4015 248.412 64.5228 243.617 72.8374C238.653 81.4103 235.254 110.39 226.665 115.355C218.343 120.198 189.08 112.61 178.788 112.61C168.495 112.61 139.233 120.166 130.91 115.355C122.337 110.39 118.931 81.4103 113.958 72.8374C109.115 64.5228 90.5481 39.4015 90.5481 29.1011C90.5481 13.4971 118.802 -3.81826 129.021 -14.046C139.241 -24.2738 163.135 -50.4688 178.747 -50.4688Z",
    fill: "#FC7545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.457 -100.921L264.065 -61.189L307.906 -54.8198L276.181 -23.8944L283.673 19.7693L244.457 -0.847649L205.241 19.7693L212.732 -23.8944L181.008 -54.8198L224.849 -61.189L244.457 -100.921Z",
    fill: "#F93838"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.948 99.4593H87.4761V84.9323C92.5091 84.9323 96.3982 84.4366 99.1435 83.4453C101.889 82.4539 103.757 80.9669 104.748 78.9842C105.816 77.0015 106.35 74.2944 106.35 70.8628H122.364V148.645H103.948V99.4593Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1Enabled);
export default __webpack_public_path__ + "static/media/1-enabled.9a2ee9ac.svg";
export { ForwardRef as ReactComponent };